import { Label } from '@cian/ui-kit';

import { FC } from 'react';

type FromOwnerLabelProps = {
  trackLabelClick(): void;
};

export const FromOwnerLabel: FC<FromOwnerLabelProps> = props => (
  <Label
    background="success_10"
    color="success_100"
    data-testid="publisher-labels.from-owner"
    onClick={props.trackLabelClick}
  >
    Собственник
  </Label>
);
